import { useLocation } from "react-router"

const CHAT_ROUTE = "chats"
const CHAT_ROOT_PAGE = `/${CHAT_ROUTE}`

export const CHAT_TAKEN_PARAM = "chatTaken"

export const getChatRoute = (threadId?: string, params?: string) => {
  if (!threadId) {
    return CHAT_ROOT_PAGE
  }

  if (!params) {
    return `/${CHAT_ROUTE}/${threadId}`
  }

  return `/${CHAT_ROUTE}/${threadId}/${params}`
}

export const getTakenChatRoute = (threadId: string) => `${getChatRoute(threadId)}?${CHAT_TAKEN_PARAM}=true`

export const useIsChatLocation = () => {
  const location = useLocation()
  return location.pathname.startsWith(CHAT_ROOT_PAGE)
}
